// AUTO-GENERATED by scripts/generate-responsive-images.js — do not edit by hand.
import gallery3710W480 from './gallery-3710-w480.webp';
import gallery3710W960 from './gallery-3710-w960.webp';
import gallery3710W1600 from './gallery-3710-w1600.webp';
import gallery4269W480 from './gallery-4269-w480.webp';
import gallery4269W960 from './gallery-4269-w960.webp';
import gallery4269W1350 from './gallery-4269-w1350.webp';
import gallery4276W480 from './gallery-4276-w480.webp';
import gallery4276W960 from './gallery-4276-w960.webp';
import gallery4276W1350 from './gallery-4276-w1350.webp';
import gallery4263W480 from './gallery-4263-w480.webp';
import gallery4263W960 from './gallery-4263-w960.webp';
import gallery4263W1350 from './gallery-4263-w1350.webp';
import gallery4237W480 from './gallery-4237-w480.webp';
import gallery4237W960 from './gallery-4237-w960.webp';
import gallery4237W1350 from './gallery-4237-w1350.webp';
import gallery4134W480 from './gallery-4134-w480.webp';
import gallery4134W960 from './gallery-4134-w960.webp';
import gallery4134W1350 from './gallery-4134-w1350.webp';
import gallery3238W480 from './gallery-3238-w480.webp';
import gallery3238W960 from './gallery-3238-w960.webp';
import gallery3238W1600 from './gallery-3238-w1600.webp';
import gallery3230W480 from './gallery-3230-w480.webp';
import gallery3230W960 from './gallery-3230-w960.webp';
import gallery3230W1350 from './gallery-3230-w1350.webp';
import gallery4038W480 from './gallery-4038-w480.webp';
import gallery4038W960 from './gallery-4038-w960.webp';
import gallery4038W1600 from './gallery-4038-w1600.webp';
import gallery4042W480 from './gallery-4042-w480.webp';
import gallery4042W960 from './gallery-4042-w960.webp';
import gallery4042W1600 from './gallery-4042-w1600.webp';
import gallery3971W480 from './gallery-3971-w480.webp';
import gallery3971W960 from './gallery-3971-w960.webp';
import gallery3971W1350 from './gallery-3971-w1350.webp';
import gallery3701W480 from './gallery-3701-w480.webp';
import gallery3701W960 from './gallery-3701-w960.webp';
import gallery3701W1600 from './gallery-3701-w1600.webp';
import gallery4050W480 from './gallery-4050-w480.webp';
import gallery4050W960 from './gallery-4050-w960.webp';
import gallery4050W1280 from './gallery-4050-w1280.webp';
import gallery4051W480 from './gallery-4051-w480.webp';
import gallery4051W960 from './gallery-4051-w960.webp';
import gallery4051W1280 from './gallery-4051-w1280.webp';
import gallery4052W480 from './gallery-4052-w480.webp';
import gallery4052W960 from './gallery-4052-w960.webp';
import gallery4052W1280 from './gallery-4052-w1280.webp';
import gallery4055W480 from './gallery-4055-w480.webp';
import gallery4055W960 from './gallery-4055-w960.webp';
import gallery4055W1280 from './gallery-4055-w1280.webp';
import as1GalleryW480 from './as1-gallery-w480.webp';
import as1GalleryW960 from './as1-gallery-w960.webp';
import as1GalleryW1200 from './as1-gallery-w1200.webp';
import as2GalleryW480 from './as2-gallery-w480.webp';
import as2GalleryW960 from './as2-gallery-w960.webp';
import as2GalleryW1024 from './as2-gallery-w1024.webp';
import as3GalleryW480 from './as3-gallery-w480.webp';
import as3GalleryW675 from './as3-gallery-w675.webp';
import as4GalleryW480 from './as4-gallery-w480.webp';
import as4GalleryW675 from './as4-gallery-w675.webp';
import as1W480 from './as1-w480.webp';
import as1W960 from './as1-w960.webp';
import as1W1400 from './as1-w1400.webp';
import campW480 from './camp-w480.webp';
import campW960 from './camp-w960.webp';
import campW1600 from './camp-w1600.webp';
import ukulelePicW480 from './ukulele-pic-w480.webp';
import ukulelePicW960 from './ukulele-pic-w960.webp';
import ukulelePicW1600 from './ukulele-pic-w1600.webp';
import guitarCasualW480 from './guitar-casual-w480.webp';
import guitarCasualW960 from './guitar-casual-w960.webp';
import guitarCasualW1063 from './guitar-casual-w1063.webp';
import kidsMusicW480 from './kids-music-w480.webp';
import kidsMusicW960 from './kids-music-w960.webp';
import kidsMusicW1080 from './kids-music-w1080.webp';
import returninplayersW480 from './returninplayers-w480.webp';
import returninplayersW612 from './returninplayers-w612.webp';

const responsiveImages = {
  'gallery-3710': {
    src: gallery3710W960,
    srcSet: [`${gallery3710W480} 480w`, `${gallery3710W960} 960w`, `${gallery3710W1600} 1600w`].join(', '),
  },
  'gallery-4269': {
    src: gallery4269W960,
    srcSet: [`${gallery4269W480} 480w`, `${gallery4269W960} 960w`, `${gallery4269W1350} 1350w`].join(', '),
  },
  'gallery-4276': {
    src: gallery4276W960,
    srcSet: [`${gallery4276W480} 480w`, `${gallery4276W960} 960w`, `${gallery4276W1350} 1350w`].join(', '),
  },
  'gallery-4263': {
    src: gallery4263W960,
    srcSet: [`${gallery4263W480} 480w`, `${gallery4263W960} 960w`, `${gallery4263W1350} 1350w`].join(', '),
  },
  'gallery-4237': {
    src: gallery4237W960,
    srcSet: [`${gallery4237W480} 480w`, `${gallery4237W960} 960w`, `${gallery4237W1350} 1350w`].join(', '),
  },
  'gallery-4134': {
    src: gallery4134W960,
    srcSet: [`${gallery4134W480} 480w`, `${gallery4134W960} 960w`, `${gallery4134W1350} 1350w`].join(', '),
  },
  'gallery-3238': {
    src: gallery3238W960,
    srcSet: [`${gallery3238W480} 480w`, `${gallery3238W960} 960w`, `${gallery3238W1600} 1600w`].join(', '),
  },
  'gallery-3230': {
    src: gallery3230W960,
    srcSet: [`${gallery3230W480} 480w`, `${gallery3230W960} 960w`, `${gallery3230W1350} 1350w`].join(', '),
  },
  'gallery-4038': {
    src: gallery4038W960,
    srcSet: [`${gallery4038W480} 480w`, `${gallery4038W960} 960w`, `${gallery4038W1600} 1600w`].join(', '),
  },
  'gallery-4042': {
    src: gallery4042W960,
    srcSet: [`${gallery4042W480} 480w`, `${gallery4042W960} 960w`, `${gallery4042W1600} 1600w`].join(', '),
  },
  'gallery-3971': {
    src: gallery3971W960,
    srcSet: [`${gallery3971W480} 480w`, `${gallery3971W960} 960w`, `${gallery3971W1350} 1350w`].join(', '),
  },
  'gallery-3701': {
    src: gallery3701W960,
    srcSet: [`${gallery3701W480} 480w`, `${gallery3701W960} 960w`, `${gallery3701W1600} 1600w`].join(', '),
  },
  'gallery-4050': {
    src: gallery4050W960,
    srcSet: [`${gallery4050W480} 480w`, `${gallery4050W960} 960w`, `${gallery4050W1280} 1280w`].join(', '),
  },
  'gallery-4051': {
    src: gallery4051W960,
    srcSet: [`${gallery4051W480} 480w`, `${gallery4051W960} 960w`, `${gallery4051W1280} 1280w`].join(', '),
  },
  'gallery-4052': {
    src: gallery4052W960,
    srcSet: [`${gallery4052W480} 480w`, `${gallery4052W960} 960w`, `${gallery4052W1280} 1280w`].join(', '),
  },
  'gallery-4055': {
    src: gallery4055W960,
    srcSet: [`${gallery4055W480} 480w`, `${gallery4055W960} 960w`, `${gallery4055W1280} 1280w`].join(', '),
  },
  'as1-gallery': {
    src: as1GalleryW960,
    srcSet: [`${as1GalleryW480} 480w`, `${as1GalleryW960} 960w`, `${as1GalleryW1200} 1200w`].join(', '),
  },
  'as2-gallery': {
    src: as2GalleryW960,
    srcSet: [`${as2GalleryW480} 480w`, `${as2GalleryW960} 960w`, `${as2GalleryW1024} 1024w`].join(', '),
  },
  'as3-gallery': {
    src: as3GalleryW675,
    srcSet: [`${as3GalleryW480} 480w`, `${as3GalleryW675} 675w`].join(', '),
  },
  'as4-gallery': {
    src: as4GalleryW675,
    srcSet: [`${as4GalleryW480} 480w`, `${as4GalleryW675} 675w`].join(', '),
  },
  'as1': {
    src: as1W960,
    srcSet: [`${as1W480} 480w`, `${as1W960} 960w`, `${as1W1400} 1400w`].join(', '),
  },
  'camp': {
    src: campW960,
    srcSet: [`${campW480} 480w`, `${campW960} 960w`, `${campW1600} 1600w`].join(', '),
  },
  'ukulele-pic': {
    src: ukulelePicW960,
    srcSet: [`${ukulelePicW480} 480w`, `${ukulelePicW960} 960w`, `${ukulelePicW1600} 1600w`].join(', '),
  },
  'guitar-casual': {
    src: guitarCasualW960,
    srcSet: [`${guitarCasualW480} 480w`, `${guitarCasualW960} 960w`, `${guitarCasualW1063} 1063w`].join(', '),
  },
  'kids-music': {
    src: kidsMusicW960,
    srcSet: [`${kidsMusicW480} 480w`, `${kidsMusicW960} 960w`, `${kidsMusicW1080} 1080w`].join(', '),
  },
  'returninplayers': {
    src: returninplayersW612,
    srcSet: [`${returninplayersW480} 480w`, `${returninplayersW612} 612w`].join(', '),
  },
};

export default responsiveImages;
